import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity'
import { createReducer, on } from '@ngrx/store'
import { loadSettings } from './settings.actions'

export interface ISettings {
  id: number
}
export const settingsFeatureName = 'settings'

export interface ISettingsState extends EntityState<ISettings> {}

export const settingsAdapter: EntityAdapter<ISettings> = createEntityAdapter<ISettings>({
  selectId: (settings: ISettings) => settings.id,
})

export const initialState: ISettingsState = settingsAdapter.getInitialState()

export const settingsReducer = createReducer(
  initialState,

  on(loadSettings, (state, { settings }) => {
    return settingsAdapter.setAll(settings, state)
  })
)
